import React, { useEffect, useState, useRef } from "react";
import ssoHandler from "../ssoHandler";
import { useParams } from "react-router-dom";
import env from "../../config";
import { useAppInfo } from "../../context/app";
import LoadingScreen from "../../components/LoadingScreen";
import IframeSendData from "../../helper/IframeSendData";
const AppIframe = () => {
  const [app] = useAppInfo();
  const { appId } = useParams();
  const [iframeUrl, setIframeUrl] = useState("");
  const { SSO, checkSSO } = ssoHandler();
  const [ssodata, setssodata] = useState(null);
  const [loader, setloader] = useState(true);
  const iframeRef = useRef(null);

  // const AppsData = async () => {
  //   const { response } = await AppService.apps.filter({
  //     query: `appId=${appId}`,
  //   });
  //   if (response) {
  //     checkSSO(response.data);
  //   }
  // };
  useEffect(() => {
    if (ssodata) {
      window.addEventListener("message", (event) => {
        if (event.data?.message === "REQUEST_SSO") {
          event.source.postMessage(
            { message: "SSO_DATA", payload: ssodata },
            event.origin
          );
        }
      });
    }
  }, [iframeRef, ssodata]);

  useEffect(() => {
    checkSSO(app);
  }, []);
  useEffect(() => {
    if (SSO != "" && SSO != undefined) {
      var data = JSON.parse(SSO);
      let url = `${env.APP_URL}/agency/${data.companyId}/${appId}/dashboard`;
      if (appId === "68b3082bbbe91bd065637b41") {
        if (data?.activeLocation) {
          url = `${env.APP_URL}/location/quo/${data.companyId}/${data.activeLocation}/${appId}/dashboard`;
        }
      } else if (appId === "68a62d8f70e465835fa7af7e") {
        if (data?.activeLocation) {
          url = `${env.APP_URL}/location/twilio/${data.companyId}/${data.activeLocation}/${appId}/dashboard`;
        }
      } else if (data?.activeLocation) {
        url = `${env.APP_URL}/location/${data.companyId}/${data.activeLocation}/${appId}/dashboard`;
      }
      setssodata(data);
      setIframeUrl(url);
      setloader(false);
    }
  }, [SSO]);
  if (loader) {
    return <LoadingScreen loadingText={"Loading data..."} />;
  }
  return (
    <div>
      <IframeSendData SSOData={ssodata} iframeUrl={iframeUrl} />
    </div>
  );
};

export default AppIframe;
